<script>
  // Pluggable icons, retro-first: a Win98-era PNG at /icons/retro/<name>.png wins,
  // then a PNG at /icons/<name>.png, then the per-app SVG fallbacks below.
  // Every icon is wrapped in a 3D slab (.icon3d) — hard outline, hover tilt,
  // and idle animations for a few personalities.
  import { extraIconData } from '../os/icons.js';
  import { retroIcons, rasterIcons, idleAnims } from '../os/icon-config.js';
  let { name, size = 32 } = $props();
  let usePng = $state(true);
  let useRetro = $state(true);

  const hasRaster = $derived(rasterIcons.has(name));
  const hasRetro = $derived(retroIcons.has(name));
</script>

<span
  class={`icon3d${idleAnims[name] ? ` anim-${idleAnims[name]}` : ''}`}
  style={`width:${size}px;height:${size}px`}
  aria-hidden="true"
>
{#if hasRetro && useRetro}
  <img
    class="os-icon retro-raster"
    src={`/icons/retro/${name}.png`}
    width={size}
    height={size}
    alt=""
    onerror={() => (useRetro = false)}
  />
{:else if hasRaster && usePng}
  <img
    class="os-icon"
    src={`/icons/${name}.png`}
    width={size}
    height={size}
    alt=""
    onerror={() => (usePng = false)}
  />
{:else if name.startsWith('folder')}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="folder-back" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#a8d6f5" /><stop offset="0.58" stop-color="#6ebae8" /><stop offset="1" stop-color="#3d9ccf" />
      </linearGradient>
      <linearGradient id="folder-front" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#d1edf8" /><stop offset="0.45" stop-color="#8ccdf0" /><stop offset="1" stop-color="#4aaae4" />
      </linearGradient>
      <linearGradient id="folder-lip" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ffffff" stop-opacity="0.82" /><stop offset="1" stop-color="#ffffff" stop-opacity="0.12" />
      </linearGradient>
    </defs>
    <path d="M8 18.5 c0 -2.8 2.2 -5 5 -5 h12.5 c1.6 0 3 .7 4 1.9 l3.1 3.6 h18.4 c3 0 5.5 2.4 5.5 5.4 v22.4 c0 3 -2.4 5.4 -5.4 5.4 h-38 c-3 0 -5.4 -2.4 -5.4 -5.4 z" fill="url(#folder-back)" stroke="#4f8ebc" stroke-width="1.25" />
    <path d="M6.5 27.5 h51 l-4.2 20.5 c-.6 3 -3.2 5.2 -6.2 5.2 h-34.2 c-3 0 -5.6 -2.2 -6.2 -5.2 z" fill="url(#folder-front)" stroke="#367fb7" stroke-width="1.25" stroke-linejoin="round" />
    <path d="M10.5 29 h43.5 l-.85 4.2 c-12.5 -3.5 -27.8 -3.3 -43.2 1.5 z" fill="url(#folder-lip)" />
    <path d="M12 18.8 h13.5 c1.3 0 2.5.55 3.3 1.55 l2.15 2.55 h22.5" fill="none" stroke="#dff4ff" stroke-width="1.1" stroke-linecap="round" opacity="0.75" />
    {#if name === 'folder-desktop'}
      <rect x="37" y="32" width="14" height="10" rx="1" fill="none" stroke="#376694" stroke-width="1.5" />
      <path d="M35 44 h18 m-9 -2 v2" fill="none" stroke="#376694" stroke-width="1.5" />
    {:else if name === 'folder-documents'}
      <path d="M38 30 h7 l4 4 v10 h-11 z" fill="none" stroke="#376694" stroke-width="1.5" />
      <path d="M45 30 v4 h4" fill="none" stroke="#376694" stroke-width="1.5" />
      <path d="M40 37 h6 m-6 3 h6 m-6 3 h4" fill="none" stroke="#376694" stroke-width="1" />
    {:else if name === 'folder-downloads'}
      <circle cx="43" cy="36" r="8" fill="none" stroke="#376694" stroke-width="1.5" />
      <path d="M43 31 v8 m-3 -3 l3 3 l3 -3" fill="none" stroke="#376694" stroke-width="1.5" stroke-linecap="round" />
    {:else if name === 'folder-library'}
      <path d="M37 34 v9 m4 -9 v9 m4 -9 v9" fill="none" stroke="#376694" stroke-width="1.5" />
      <path d="M35 34 h14 M35 43 h14 M38 31 v3 M44 31 v3" fill="none" stroke="#376694" stroke-width="1" />
    {:else if name === 'folder-movies'}
      <rect x="36" y="31" width="14" height="12" fill="none" stroke="#376694" stroke-width="1.5" />
      <path d="M36 34 h14 M36 40 h14 M40 31 v12 M46 31 v12" fill="none" stroke="#376694" stroke-width="0.8" />
    {:else if name === 'folder-music'}
      <path d="M39 42 a 2.5 2 0 1 1 -2.5 -2 v -8 l 7 -2 v 8 a 2.5 2 0 1 1 -2.5 -2 v -6 l -4 1.2" fill="none" stroke="#376694" stroke-width="1.5" />
    {:else if name === 'folder-pictures'}
      <rect x="36" y="32" width="14" height="11" rx="1" fill="none" stroke="#376694" stroke-width="1.5" />
      <circle cx="40" cy="36" r="1.5" fill="#376694" />
      <path d="M36 43 l3 -3 l2 1 l4 -4 l5 5" fill="none" stroke="#376694" stroke-width="1.5" stroke-linejoin="round" />
    {:else if name === 'folder-public'}
      <circle cx="43" cy="35" r="3" fill="none" stroke="#376694" stroke-width="1.5" />
      <path d="M38 43 c 0 -3 2 -5 5 -5 s 5 2 5 5" fill="none" stroke="#376694" stroke-width="1.5" />
    {:else if name === 'folder-sites'}
      <circle cx="43" cy="37" r="7" fill="none" stroke="#376694" stroke-width="1.5" />
      <path d="M36 37 h14 M43 30 c -3 0 -4 3 -4 7 s 1 7 4 7 s 4 -3 4 -7 s -1 -7 -4 -7 z" fill="none" stroke="#376694" stroke-width="1" />
    {/if}
  </svg>
{:else if name === 'finder'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="finder-blue" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#b9ecff" /><stop offset="0.48" stop-color="#48a9ee" /><stop offset="1" stop-color="#1260bc" />
      </linearGradient>
      <linearGradient id="finder-silver" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ffffff" /><stop offset="1" stop-color="#b9c3ce" />
      </linearGradient>
    </defs>
    <rect x="6" y="7" width="52" height="50" rx="12" fill="url(#finder-blue)" stroke="#0d4f95" stroke-width="1.5" />
    <path d="M32 7v50" stroke="#0d4f95" stroke-width="1.2" opacity="0.65" />
    <path d="M10 13h44v14c-13-6-29-6-44 0z" fill="#fff" opacity="0.34" />
    <path d="M19 25c2-3 6-3 8 0M39 25c2-3 6-3 8 0" fill="none" stroke="#073760" stroke-width="2" stroke-linecap="round" />
    <path d="M28 34c3 3 9 3 12 0" fill="none" stroke="#073760" stroke-width="2" stroke-linecap="round" />
    <path d="M32 12c-8 6-10 17-7 28" fill="none" stroke="url(#finder-silver)" stroke-width="2" opacity="0.8" />
  </svg>
{:else if name === 'hard-drive'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="hd-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#e0e4e8" /><stop offset="1" stop-color="#9fa8b0" />
      </linearGradient>
      <linearGradient id="hd-plate" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ffffff" /><stop offset="1" stop-color="#ccd4dc" />
      </linearGradient>
    </defs>
    <rect x="12" y="8" width="40" height="48" rx="6" fill="url(#hd-body)" stroke="#606b76" stroke-width="1.5" />
    <rect x="16" y="12" width="32" height="34" rx="3" fill="url(#hd-plate)" stroke="#818e9a" stroke-width="1" />
    <circle cx="32" cy="29" r="11" fill="none" stroke="#e0e4e8" stroke-width="2" />
    <circle cx="32" cy="29" r="4" fill="#a4b0ba" />
    <path d="M12 48h40" stroke="#717d87" stroke-width="1.5" />
    <circle cx="20" cy="52" r="1.5" fill="#50e3c2" />
  </svg>
{:else if name === 'welcome'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <radialGradient id="welcome-orb" cx="36%" cy="24%" r="74%">
        <stop offset="0" stop-color="#fff8cc" /><stop offset="0.42" stop-color="#ffb238" /><stop offset="1" stop-color="#c54b18" />
      </radialGradient>
      <linearGradient id="welcome-screen" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#eaf7ff" /><stop offset="1" stop-color="#6ba9e2" />
      </linearGradient>
    </defs>
    <rect x="9" y="10" width="46" height="36" rx="7" fill="#dfe7ef" stroke="#758697" stroke-width="1.5" />
    <rect x="14" y="15" width="36" height="24" rx="3" fill="url(#welcome-screen)" />
    <circle cx="43" cy="22" r="9" fill="url(#welcome-orb)" stroke="#9a3f16" stroke-width="1" />
    <path d="M22 35c6-7 13-8 24-2" fill="none" stroke="#fff" stroke-width="2" opacity="0.75" />
    <rect x="27" y="46" width="10" height="6" fill="#a9b4bf" />
    <rect x="18" y="52" width="28" height="5" rx="2.5" fill="#d5dce4" stroke="#7b8793" />
  </svg>
{:else if name === 'resume'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="resume-page" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ffffff" /><stop offset="1" stop-color="#dbe8f5" />
      </linearGradient>
      <linearGradient id="resume-ribbon" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ff7b7b" /><stop offset="1" stop-color="#be1e2d" />
      </linearGradient>
    </defs>
    <path d="M15 5h25l11 11v41a3 3 0 0 1-3 3H15a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3z" fill="url(#resume-page)" stroke="#8fa0b2" stroke-width="1.5" />
    <path d="M40 5v12h11" fill="#ccd9e6" stroke="#8fa0b2" stroke-width="1.5" />
    <rect x="18" y="22" width="28" height="11" rx="2" fill="url(#resume-ribbon)" />
    <text x="32" y="30.5" text-anchor="middle" font-size="8" font-family="Lucida Grande, Arial" font-weight="700" fill="#fff">PDF</text>
    <path d="M19 40h26M19 46h22M19 52h18" stroke="#5b8fc9" stroke-width="2" stroke-linecap="round" />
  </svg>
{:else if name === 'content-editor'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="editor-board" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#f9fbff" /><stop offset="1" stop-color="#91a7bd" />
      </linearGradient>
      <linearGradient id="editor-pencil" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ffe08a" /><stop offset="1" stop-color="#d18820" />
      </linearGradient>
    </defs>
    <rect x="10" y="8" width="38" height="48" rx="5" fill="url(#editor-board)" stroke="#6c7c8d" stroke-width="1.5" />
    <path d="M18 22h22M18 30h22M18 38h15" stroke="#406f9c" stroke-width="2" stroke-linecap="round" />
    <path d="M38 47l12-28 5 2-12 28-7 5z" fill="url(#editor-pencil)" stroke="#8a5515" stroke-width="1.2" stroke-linejoin="round" />
    <path d="M50 19l2-5 5 2-2 5z" fill="#e95d55" stroke="#99332e" stroke-width="1" />
  </svg>
{:else if name === 'system-folder'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="sys-folder" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#d7e1ea" /><stop offset="1" stop-color="#718395" />
      </linearGradient>
    </defs>
    <path d="M8 18c0-3 2-5 5-5h12l4 5h22c3 0 5 2 5 5v24c0 3-2 5-5 5H13c-3 0-5-2-5-5z" fill="url(#sys-folder)" stroke="#526271" stroke-width="1.4" />
    <circle cx="43" cy="37" r="9" fill="#eef3f7" stroke="#526271" stroke-width="1.2" />
    <path d="M43 29v16M35 37h16" stroke="#526271" stroke-width="2" />
  </svg>
{:else if name === 'idisk'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="idisk-case" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#f8fbff" /><stop offset="0.48" stop-color="#a9c9eb" /><stop offset="1" stop-color="#5d78a4" />
      </linearGradient>
      <radialGradient id="idisk-globe" cx="35%" cy="25%" r="72%">
        <stop offset="0" stop-color="#e8ffff" /><stop offset="0.5" stop-color="#42b7f0" /><stop offset="1" stop-color="#1c5eb0" />
      </radialGradient>
    </defs>
    <rect x="10" y="8" width="44" height="50" rx="6" fill="url(#idisk-case)" stroke="#60748c" stroke-width="1.5" />
    <rect x="16" y="14" width="32" height="18" rx="3" fill="#eef4fb" stroke="#778da5" />
    <circle cx="32" cy="39" r="12" fill="url(#idisk-globe)" stroke="#1f5f9e" stroke-width="1.2" />
    <path d="M20 39h24M32 27c-5 4-6 20 0 24M32 27c5 4 6 20 0 24" fill="none" stroke="#e8ffff" stroke-width="1.1" opacity="0.82" />
    <path d="M16 11h32v8c-10-4-21-4-32 0z" fill="#fff" opacity="0.5" />
  </svg>
{:else if name === 'image-file' || name === 'movie-file' || name === 'audio-file' || name === 'archive' || name === 'package' || name === 'font-file' || name === 'web-link'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="media-page" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#fff" /><stop offset="1" stop-color="#dce8f5" />
      </linearGradient>
      <linearGradient id="media-badge" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#9ee8ff" /><stop offset="1" stop-color="#126ccb" />
      </linearGradient>
    </defs>
    <path d="M15 5h24l12 12v40a3 3 0 0 1-3 3H15a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3z" fill="url(#media-page)" stroke="#8fa0b2" stroke-width="1.5" />
    <path d="M39 5v12h12z" fill="#d0deeb" stroke="#8fa0b2" stroke-width="1.5" />
    {#if name === 'image-file'}
      <rect x="19" y="26" width="27" height="20" rx="2" fill="#cfeeff" stroke="#4788bf" />
      <circle cx="26" cy="33" r="3" fill="#ffd65a" />
      <path d="M20 46l9-9 5 4 6-7 7 12z" fill="#4aa85f" />
    {:else if name === 'movie-file'}
      <rect x="18" y="23" width="29" height="25" rx="2" fill="#303947" />
      <path d="M29 29l12 7-12 7z" fill="#fff" />
      <path d="M18 28h29M18 43h29M23 23v25M42 23v25" stroke="#9fb0c2" stroke-width="1" />
    {:else if name === 'audio-file'}
      <path d="M25 43a5 4 0 1 1-1-3V25l18-5v17a5 4 0 1 1-3-4V24l-14 4z" fill="#2f80d1" />
    {:else}
      <rect x="20" y="27" width="26" height="18" rx="3" fill="url(#media-badge)" />
      <path d="M24 36h18" stroke="#fff" stroke-width="3" stroke-linecap="round" opacity="0.9" />
    {/if}
  </svg>
{:else if name === 'mail'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="mail-paper" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#fff" /><stop offset="1" stop-color="#dce9f7" />
      </linearGradient>
      <linearGradient id="mail-stamp" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#8ed0ff" /><stop offset="1" stop-color="#146ccb" />
      </linearGradient>
    </defs>
    <rect x="8" y="14" width="48" height="36" rx="6" fill="url(#mail-paper)" stroke="#8ca4bd" stroke-width="1.5" />
    <path d="M10 18 l22 18 l22 -18" fill="none" stroke="#77a9da" stroke-width="2" stroke-linejoin="round" />
    <path d="M10 48 l18 -17 m26 17 l-18 -17" fill="none" stroke="#b0c2d6" stroke-width="1.7" stroke-linecap="round" />
    <rect x="41" y="20" width="8" height="8" rx="1.5" fill="url(#mail-stamp)" />
  </svg>
{:else if name === 'gear'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <radialGradient id="gear-face" cx="35%" cy="25%" r="70%">
        <stop offset="0" stop-color="#ffffff" /><stop offset="0.52" stop-color="#b9c8d8" /><stop offset="1" stop-color="#657b91" />
      </radialGradient>
    </defs>
    <path d="M36 6 l3 8 a20 20 0 0 1 5 2 l8 -4 l6 10 l-7 6 a18 18 0 0 1 0 6 l7 6 l-6 10 l-8 -4 a20 20 0 0 1 -5 2 l-3 8 h-12 l-3 -8 a20 20 0 0 1 -5 -2 l-8 4 l-6 -10 l7 -6 a18 18 0 0 1 0 -6 l-7 -6 l6 -10 l8 4 a20 20 0 0 1 5 -2 l3 -8 z" fill="url(#gear-face)" stroke="#566a7d" stroke-width="1.5" stroke-linejoin="round" />
    <circle cx="30" cy="31" r="12" fill="#f7fbff" stroke="#60788f" stroke-width="1.4" />
    <circle cx="30" cy="31" r="5" fill="#6faee8" />
  </svg>
{:else if name === 'game'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="game-case" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#f8fcff" /><stop offset="0.55" stop-color="#96bad8" /><stop offset="1" stop-color="#526f88" />
      </linearGradient>
    </defs>
    <path d="M15 24 h34 a9 9 0 0 1 8 6 l4 14 a8 8 0 0 1 -13 8 l-5 -6 h-22 l-5 6 a8 8 0 0 1 -13 -8 l4 -14 a9 9 0 0 1 8 -6 z" fill="url(#game-case)" stroke="#4f677f" stroke-width="1.5" />
    <path d="M18 33 h13 m-6 -6 v12" stroke="#254d78" stroke-width="3" stroke-linecap="round" />
    <circle cx="43" cy="33" r="3" fill="#22bd56" stroke="#147a37" />
    <circle cx="51" cy="40" r="3" fill="#e84f4a" stroke="#a42725" />
    <path d="M14 27 h36 c3 0 5 2 6 5 c-13 -5 -30 -5 -45 0 c1 -3 2 -5 3 -5 z" fill="#fff" opacity="0.38" />
  </svg>
{:else if name === 'chat'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="chat-g" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#abf0ff" /><stop offset="0.5" stop-color="#2e9cf0" /><stop offset="1" stop-color="#0d56a7" />
      </linearGradient>
      <linearGradient id="chat-gloss" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#fff" stop-opacity="0.92" /><stop offset="1" stop-color="#fff" stop-opacity="0.08" />
      </linearGradient>
    </defs>
    <rect x="6" y="6" width="52" height="52" rx="14" fill="url(#chat-g)" stroke="#15457c" stroke-width="1.5" />
    <rect x="10" y="9" width="44" height="20" rx="10" fill="url(#chat-gloss)" />
    <path d="M19 23 h26 a5 5 0 0 1 5 5 v9 a5 5 0 0 1 -5 5 h-12 l-10 7 v-7 h-4 a5 5 0 0 1 -5 -5 v-9 a5 5 0 0 1 5 -5 z" fill="#fff" opacity="0.96" />
    <circle cx="27" cy="33" r="2.2" fill="#2c83d8" /><circle cx="34" cy="33" r="2.2" fill="#2c83d8" /><circle cx="41" cy="33" r="2.2" fill="#2c83d8" />
  </svg>
{:else if name === 'computer'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="mon-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ffffff" /><stop offset="0.5" stop-color="#cfdbe7" /><stop offset="1" stop-color="#8a9aac" />
      </linearGradient>
      <linearGradient id="mon-screen" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#74d7ff" /><stop offset="1" stop-color="#14529a" />
      </linearGradient>
    </defs>
    <rect x="6" y="8" width="52" height="38" rx="7" fill="url(#mon-body)" stroke="#738295" stroke-width="1.5" />
    <rect x="11" y="13" width="42" height="26" rx="3" fill="url(#mon-screen)" stroke="#0e3567" stroke-width="1" />
    <path d="M13 15 h38 v8 c-12 -5 -25 -5 -38 0 z" fill="#fff" opacity="0.28" />
    <circle cx="32" cy="42" r="1.7" fill="#6d7f91" />
    <rect x="27" y="46" width="10" height="6" fill="#aeb7c2" />
    <rect x="18" y="52" width="28" height="5" rx="2.5" fill="url(#mon-body)" stroke="#7c8794" stroke-width="1" />
  </svg>
{:else if name === 'trash'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="trash-rim" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#f4f6f8" /><stop offset="1" stop-color="#7d858d" />
      </linearGradient>
      <linearGradient id="trash-wire" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#d7dce1" /><stop offset="1" stop-color="#68717a" />
      </linearGradient>
      <radialGradient id="trash-glass" cx="45%" cy="10%" r="90%">
        <stop offset="0" stop-color="#ffffff" stop-opacity="0.75" />
        <stop offset="0.5" stop-color="#c8ced5" stop-opacity="0.42" />
        <stop offset="1" stop-color="#66717d" stop-opacity="0.76" />
      </radialGradient>
    </defs>
    <ellipse cx="32" cy="14" rx="20" ry="7" fill="url(#trash-rim)" stroke="#68717a" stroke-width="1.4" />
    <path d="M13 16 l5 37 c.5 4 4 6 14 6 s13.5 -2 14 -6 l5 -37 c-5 4 -33 4 -38 0 z" fill="url(#trash-glass)" stroke="#68717a" stroke-width="1.4" />
    <ellipse cx="32" cy="16" rx="18" ry="5" fill="#eef1f4" opacity="0.65" />
    <g stroke="url(#trash-wire)" stroke-width="1.2" opacity="0.9">
      <path d="M21 20 l3 35" />
      <path d="M29 21 l1 36" />
      <path d="M37 21 l-1 36" />
      <path d="M45 20 l-3 35" />
      <path d="M17 30 c7 3 23 3 30 0" />
      <path d="M18 41 c7 3 21 3 28 0" />
      <path d="M20 51 c6 2 18 2 24 0" />
    </g>
  </svg>
{:else if name === 'calculator'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="calc-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#4a4a4e"/><stop offset="1" stop-color="#2a2a2e"/>
      </linearGradient>
    </defs>
    <rect x="8" y="6" width="48" height="52" rx="7" fill="url(#calc-body)" stroke="#222" stroke-width="1.5"/>
    <rect x="13" y="11" width="38" height="14" rx="3" fill="#1c1c1e" stroke="#555" stroke-width="1"/>
    <text x="45" y="23" text-anchor="end" fill="#fff" font-size="11" font-family="monospace">0</text>
    <!-- buttons -->
    <rect x="13" y="30" width="8" height="7" rx="2" fill="#636366"/><rect x="24" y="30" width="8" height="7" rx="2" fill="#636366"/><rect x="35" y="30" width="8" height="7" rx="2" fill="#636366"/><rect x="46" y="30" width="8" height="7" rx="2" fill="#ff9500"/>
    <rect x="13" y="40" width="8" height="7" rx="2" fill="#48484a"/><rect x="24" y="40" width="8" height="7" rx="2" fill="#48484a"/><rect x="35" y="40" width="8" height="7" rx="2" fill="#48484a"/><rect x="46" y="40" width="8" height="7" rx="2" fill="#ff9500"/>
    <rect x="13" y="50" width="20" height="7" rx="2" fill="#48484a"/><rect x="35" y="50" width="8" height="7" rx="2" fill="#48484a"/><rect x="46" y="50" width="8" height="7" rx="2" fill="#ff9500"/>
  </svg>
{:else if name === 'terminal'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="term-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#1a1a1a"/><stop offset="1" stop-color="#0d0d0d"/>
      </linearGradient>
    </defs>
    <rect x="6" y="8" width="52" height="48" rx="6" fill="url(#term-body)" stroke="#333" stroke-width="1.5"/>
    <rect x="6" y="8" width="52" height="13" rx="6" fill="#2d2d2d"/>
    <rect x="6" y="16" width="52" height="5" fill="#2d2d2d"/>
    <circle cx="16" cy="15" r="3.5" fill="#ff5f56" stroke="#e0433a" stroke-width="0.6"/>
    <circle cx="26" cy="15" r="3.5" fill="#ffbd2e" stroke="#dea123" stroke-width="0.6"/>
    <circle cx="36" cy="15" r="3.5" fill="#27c93f" stroke="#1aab29" stroke-width="0.6"/>
    <text x="12" y="34" fill="#3fb950" font-size="8" font-family="monospace">$ ls -la</text>
    <text x="12" y="44" fill="#79c0ff" font-size="7" font-family="monospace">Documents/</text>
    <text x="12" y="52" fill="#3fb950" font-size="8" font-family="monospace">$ <tspan fill="#79c0ff">█</tspan></text>
  </svg>
{:else if name === 'notes'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="notes-bg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ffd60a"/><stop offset="1" stop-color="#e8b800"/>
      </linearGradient>
    </defs>
    <rect x="8" y="6" width="48" height="52" rx="6" fill="url(#notes-bg)" stroke="#c9a000" stroke-width="1.5"/>
    <rect x="8" y="6" width="48" height="12" rx="6" fill="#ff9500"/>
    <rect x="8" y="12" width="48" height="6" fill="#ff9500"/>
    <rect x="13" y="24" width="30" height="2.5" rx="1" fill="rgba(0,0,0,0.3)"/>
    <rect x="13" y="31" width="26" height="2.5" rx="1" fill="rgba(0,0,0,0.2)"/>
    <rect x="13" y="38" width="28" height="2.5" rx="1" fill="rgba(0,0,0,0.2)"/>
    <rect x="13" y="45" width="20" height="2.5" rx="1" fill="rgba(0,0,0,0.15)"/>
  </svg>
{:else if name === 'calendar'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="cal-bg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#fff"/><stop offset="1" stop-color="#e0e0e0"/>
      </linearGradient>
    </defs>
    <rect x="10" y="12" width="44" height="42" rx="4" fill="url(#cal-bg)" stroke="#999" stroke-width="1.5"/>
    <rect x="10" y="12" width="44" height="12" rx="4" fill="#d93b3b"/>
    <path d="M10 24h44M20 8v8M44 8v8" stroke="#999" stroke-width="2"/>
    <text x="32" y="44" text-anchor="middle" font-size="20" font-family="sans-serif" font-weight="bold" fill="#333">17</text>
  </svg>
{:else if name === 'stickies'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <rect x="12" y="14" width="40" height="40" fill="#fdfd86" stroke="#d4d440" stroke-width="1.5"/>
    <path d="M12 54l8-8v8h-8z" fill="#d4d440"/>
  </svg>
{:else if name === 'activity-monitor'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <circle cx="32" cy="32" r="24" fill="#111" stroke="#444" stroke-width="2"/>
    <path d="M14 32 l10 -8 l8 16 l6 -10 l12 4" fill="none" stroke="#0f0" stroke-width="2"/>
  </svg>
{:else if name === 'software-update'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <rect x="12" y="16" width="40" height="32" rx="2" fill="#222" stroke="#555" stroke-width="2"/>
    <path d="M22 32h20M32 22v20l8-8" stroke="#0a84ff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
{:else if name === 'gallery'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <rect x="10" y="14" width="44" height="36" rx="2" fill="#fff" stroke="#666" stroke-width="1.5"/>
    <circle cx="22" cy="24" r="4" fill="#f5a623"/>
    <path d="M10 50l14-14 8 8 10-12 12 14" fill="#4a90e2"/>
  </svg>
{:else if name === 'quicktime'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <circle cx="32" cy="32" r="24" fill="#111" stroke="#0a84ff" stroke-width="2"/>
    <path d="M26 22v20l14-10z" fill="#0a84ff"/>
  </svg>
{:else if name === 'aquapaint'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <path d="M48 16c0-6-6-6-6-6s-4 12-16 12-16 10-16 20 8 16 22 16 24-10 24-22c0-10-8-20-8-20z" fill="#ff9500" stroke="#cc7700" stroke-width="1.5"/>
    <circle cx="24" cy="44" r="5" fill="#111"/>
    <circle cx="40" cy="44" r="4" fill="#0a84ff"/>
    <circle cx="32" cy="30" r="3" fill="#ff3b30"/>
    <path d="M20 20l10-10 6 6-10 10z" fill="#cc7700"/>
    <path d="M18 22l4-4-2-2-4 4z" fill="#fff"/>
  </svg>
{:else if name === 'music'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <circle cx="32" cy="32" r="24" fill="#111" stroke="#007aff" stroke-width="2"/>
    <circle cx="32" cy="32" r="10" fill="#222" stroke="#444" stroke-width="1.5"/>
    <circle cx="32" cy="32" r="3" fill="#007aff"/>
    <path d="M28 16v24c0 2-2 3-4 3s-4-1-4-3 2-4 4-4v-16l14-4v24c0 2-2 3-4 3s-4-1-4-3 2-4 4-4v-20z" fill="#007aff"/>
  </svg>
{:else if name === 'freeform'}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <rect x="8" y="12" width="48" height="40" rx="4" fill="#2a2a2a" stroke="#666" stroke-width="1.5"/>
    <rect x="14" y="18" width="16" height="16" fill="#fdfd86" stroke="#d4d440" stroke-width="1" transform="rotate(-5 22 26)"/>
    <rect x="34" y="24" width="16" height="12" fill="#fff" stroke="#999" stroke-width="1" transform="rotate(8 42 30)"/>
    <path d="M16 42h32M16 46h24" stroke="#888" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
{:else if extraIconData[name]}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    {@html extraIconData[name]}
  </svg>
{:else}
  <svg class="os-icon" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
    <defs>
      <linearGradient id="doc-gloss" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#fff" /><stop offset="0.5" stop-color="#fbfdff" /><stop offset="1" stop-color="#dce8f5" />
      </linearGradient>
      <linearGradient id="doc-seal" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#88ceff" /><stop offset="1" stop-color="#126ccb" />
      </linearGradient>
    </defs>
    <path d="M15 5 h24 l12 12 v40 a3 3 0 0 1 -3 3 h-33 a3 3 0 0 1 -3 -3 v-49 a3 3 0 0 1 3 -3 z" fill="url(#doc-gloss)" stroke="#8fa0b2" stroke-width="1.5" stroke-linejoin="round" />
    <path d="M39 5 v12 h12 z" fill="#d0deeb" stroke="#8fa0b2" stroke-width="1.5" stroke-linejoin="round" />
    <path d="M16 8 h21 v8 c-7 -2 -14 -2 -21 1 z" fill="#fff" opacity="0.7" />
    <g stroke="#5b8fc9" stroke-width="2" stroke-linecap="round">
      <line x1="20" y1="29" x2="44" y2="29" /><line x1="20" y1="36" x2="44" y2="36" />
      <line x1="20" y1="43" x2="38" y2="43" />
    </g>
    <circle cx="43" cy="49" r="6" fill="url(#doc-seal)" stroke="#0756ad" />
  </svg>
{/if}
</span>

<!-- .icon3d / idle-animation styles live globally in app.css (keeps this file small) -->
